<template>
  <div class="PhoneInputBox">
    <div class="phone-con input-row">
      <div class="prefix" :class="disabled ? 'disabled_prefix' : ''" @click.stop="selectOpen">
        <span class="selected">{{ mobileAreaCode }}</span><img class="icon_choice"
          src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/signUp/icon_an%402x.png" alt="">
        <div class="select_region" v-show="selectFlag">
          <h3>{{ $t('signUp.text14') }}<img class="close"
              src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/h5_pop_icon_del%402x.png" /></h3>
          <div class="seach">
            <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/web/icon_search%402x.png" alt="">
            <input type="text" @click.stop="stopPropagation" @input="seachList" v-model="seachWord" id="seachVal" />
          </div>
          <ul class="seach_list sort_box">  
            <li :class="code == item.code ? 'sort_list_active' : ''" class="sort_list" v-for="item in countrysListShow"
              @click.stop="countrysChoose(item)" :key="item.name">{{ item.name }}（{{ item.code }}）</li>
          </ul>
        </div>
      </div>
      <div class="value">
        <input :disabled="disabled" type="text" @input="blurFunc(phone)" v-model="phone"
          :placeholder="$t('signUp.text13')" />
      </div>
    </div>
  </div>
</template>
<script>
import {
  ref,
  reactive,
  toRefs,
  defineEmits
} from 'vue';
import { assignParams } from '@/until/common';
import apiService from '@/api/request';
export default {
  name: 'PhoneInputBox',
  props: {
    value: { // 输入框的值
      type: String,
      default: '',
    },
    laceholder: { // 输入框的提示
      type: String,
      default: '',
    },
    blurFunc: { // 失去焦点的回调事件
      type: Function,
    },
    code: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: true
    },
  },
  setup(props, ctx) {

    const phone = ref('');
    const mobileAreaCode = ref('');
    const { value, code, disabled } = toRefs(props);
    phone.value = value.value;
    mobileAreaCode.value = code.value;
    const seachWord = ref('')
    /**
     * 获取国家编码-start
     */
    console.log(disabled.value,disabled)
    const countrysList = ref([]);//储存所有区号
    const countrysListShow = ref([]);//渲染用
    const countryId = ref('');
    if (!disabled.value) {
      GetCountrys();
    }

    function stopPropagation(){

    }
    function GetCountrys() {
      let params = assignParams({ clientType: 'web' });
      apiService.GetCountrys(params).then((res) => {
        countrysList.value = res.data.list;
        countrysListShow.value = res.data.list;
        mobileAreaCode.value = res.data.defaultCountry.code;
        countryId.value = res.data.defaultCountry.countryid;
        ctx.emit('mobileAreaCodeChange', mobileAreaCode.value)
      })
    }
    /** 获取国家编码-end */
    /**
         * 选择国家编码弹框消失与隐藏切换-start
         */
    const selectFlag = ref(false);//选择区号框
    function selectOpen() {
      console.log(selectFlag.value)
      if (props.disabled) {
        return
      }
      selectFlag.value = !selectFlag.value
    }
    /**
     * 选择国家编码弹框消失与隐藏切换-end
     */

    /**
    * 搜索国家取号-start
    */
    function seachList() {
      let list = [];
      countrysList.value.forEach(item => {
        if (item.name.toLowerCase().indexOf(seachWord.value.toLowerCase()) != -1 || item.code.toLowerCase().indexOf(seachWord.value) != -1) {
          list.push(item)
        }
      })
      countrysListShow.value = list

    }
    /**
   * 选择国家区号-start
   */

    function countrysChoose(item) {
      mobileAreaCode.value = item.code;
      countryId.value = item.countryid;
      selectFlag.value = false;
      ctx.emit('mobileAreaCodeChange', mobileAreaCode.value)
    }
    /**
     * 选择国家区号-end
     */
    /**
     * 搜索国家取号-end
     */
    return {
      seachList,
      seachWord,
      selectFlag,
      countrysList,
      selectOpen,
      mobileAreaCode,
      phone,
      countrysListShow,
      countrysChoose,
      stopPropagation
    }
  }
}
</script>
<style lang="less" scoped>
.PhoneInputBox {
  .input-row {
    margin: 0 auto;
    background: white;
    display: flex;
    justify-content: left;
    margin-bottom: 20px;
    /*no*/
    border-radius: 4px;
    height: 40px;
    /*no*/
    position: relative;
    border: 1px solid #EBEBEB;

    /*no*/
    .value {
      width: 100%;
      /*no*/
    }

    .password-icon {
      position: absolute;
      right: 16px;
      /*no*/
      top: 10px;
      /*no*/
      cursor: pointer;
    }

    .send {
      position: absolute;
      right: 10px;
      /*no*/
      top: 4px;
      /*no*/
    }

    .prefix {
      width: 80px;
      /*no*/
      padding-left: 10px;
      /*no*/
      border-right: 1px solid #EBEBEB;
      /*no*/
      text-align: left;
      cursor: pointer;
      position: relative;
      line-height: 37px;

      /*no*/
      .icon_search {
        position: relative;
        top: 8px;
        /*no*/
      }

      .icon_choice {
        width: 8px;
        /*no*/
        position: absolute;
        right: 9px;
        /*no*/
        top: 18px;
        /*no*/
      }

      .select_region {
        position: absolute;
        left: 0;
        padding: 20px 0;
        background: white;
        width: 300px;
        height: 490px;
        z-index: 9;
        top: 50px;
        box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.1);

        h3 {
          font-size: 16px;
          text-align: center;
          color: #111E36;
          position: relative;

          img {
            display: none;
          }
        }

        .seach {
          width: 284px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 2px;
          margin: 0 auto;
          border: 1px solid #DADADA;
          display: flex;
          justify-content: space-between;
          padding-left: 13px;
          margin-top: 19px;

          img {
            display: block;
            width: 12px;
            height: 12px;
            position: relative;
            top: 8px;
          }

          input {
            width: 100%;
            height: 28px;
            line-height: 28px;
            padding-left: 0;
          }
        }

        ul {
          width: 100%;
          height: 360px;
          margin-top: 12px;
          overflow-y: scroll;
          text-align: left;

          li {
            height: 45px;
            padding: 13px 16px;
            border-bottom: 1px solid #F8F9FB;
            cursor: pointer;
            line-height: 20px;
          }

          li:hover {
            background: #F7F8FA;
            color: #51B4F1;
          }

          .sort_list_active {
            background: #F7F8FA;
            color: #51B4F1;
          }
        }
      }
    }

    .disabled_prefix {
      background: rgba(239, 239, 239, 0.3);
    }

    input {
      height: 20px;
      /*no*/
      outline: none;
      padding-left: 16px;
      /*no*/
      width: 100%;
      height: 100%;
    }

    .value_code {
      padding-left: 10px;
      /*no*/
    }

  }
}
</style>
